export const hotjarUserAttribute = (userId: string, attributes?: {[key: string]: string}) => {
    if (!window['hj']) {
        return;
    }
    window['hj']('identify', userId, {
        external_id: userId,
        ...attributes
    });
};
